import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowLeft from "./images/ArrowLeft.png";
import ListViewimg from "./images/ListViewimg.png";
import Shipped from "./images/Shipped.png";
import Purchased from "./images/Purchased.png";
import PurchaseOrderimg from "./images/PurchaseOrderimg.png";
import CardboardBox from "./images/CardboardBox.png";
import DeliveryPartner from "./images/Delivery_partener_assigned.png"; // Add this import

const TrackItems = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const quotationId = location.state?.quotationId;
  const deliveryGroupId = location.state?.deliveryGroupId;
  console.log('deliveryGroupId', deliveryGroupId);
  const [quotationData, setQuotationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;

  const [steps, setSteps] = useState([
  { label: "Order Confirmed", completed: false, statuses: ["Pending", "Delivery Group Created"] },
  { label: "Order Items Packed", completed: false, statuses: ["All Items Packed"] },
  { label: "Delivery Partner Assigned", completed: false, statuses: ["Delivery Partner Assigned"] },
  { label: "Order Items Out For Delivery", completed: false, statuses: ["Out For Delivery"] },
  { label: "Order Delivered", completed: false, statuses: ["Delivered"] },
]);


  const stepImages = {
    "Order Confirmed": ListViewimg,
    "Order Items Packed": CardboardBox,
    "Delivery Partner Assigned": DeliveryPartner, // Add this line
    "Order Items Out For Delivery": Shipped,
    "Order Delivered": Purchased,
  };

useEffect(() => {
  if (quotationId) {
    fetchQuotationDetails(quotationId);   // this will call fetchOrderStatus internally
  }
}, [quotationId, deliveryGroupId]);


  const fetchQuotationDetails = async () => {
  try {
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    const token = userData?.token;
    const response = await fetch(
      `${fetchUrl}customer/quotations/get-quotation-by-its-id?quotation_id=${quotationId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );
    const data = await response.json();
    console.log("Quotation Data:", data);

    if (data.success) {
      setQuotationData(data.data);

      // Call order status API after quotation details load
      if (deliveryGroupId) {
        fetchOrderStatus(deliveryGroupId);
      }
    } else {
      console.error("Failed to fetch quotation:", data.message);
    }
  } catch (error) {
    console.error("Error fetching quotation:", error);
  } finally {
    setLoading(false);
  }
};

const fetchOrderStatus = async (deliveryGroupId) => {
  try {
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    const token = userData?.token;

    const response = await fetch(
      `${fetchUrl}customer/quotations/get-order-status-tracking?delivery_group_id=${deliveryGroupId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      }
    );

    const data = await response.json();
    console.log("Order Status Data:", data);

    if (data.success) {
      const status = data.data.status;

      // ✅ Single step update logic
      setSteps((prevSteps) => {
        const currentStepIndex = prevSteps.findIndex((step) =>
          step.statuses.includes(status)
        );
        return prevSteps.map((step, index) => ({
          ...step,
          completed: index <= currentStepIndex && currentStepIndex !== -1,
        }));
      });
    } else {
      console.error("Failed to fetch order status:", data.message);
    }
  } catch (error) {
    console.error("Error fetching order status:", error);
  }
};

const matchingDeliveryGroup = quotationData?.delivery_groups?.find(
  (group) => group.delivery_group_id === deliveryGroupId
);

if (loading) {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white bg-opacity-70 backdrop-blur-sm z-50">
      {/* 🔴 Red spinning circle */}
      <div className="w-12 h-12 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
      
      {/* Text below loader */}
      <p className="mt-4 text-red-400 font-medium text-md">Loading...</p>
    </div>
  );
}


  return (
    <div className="min-h-screen bg-white flex flex-col font-sans pb-28">
      {/* Header */}
      <div className="border-b border-gray-200 shadow-sm sticky top-0 z-30 bg-white">
        <div className="flex items-center px-2 py-3">
          <button onClick={() => navigate(-1)} className="p-1 mr-2 rounded hover:bg-gray-100">
            <img src={ArrowLeft} alt="Back" className="w-10 h-6" />
          </button>
          <h2 className="text-md font-semibold text-gray-800">Track Order</h2>
        </div>
      </div>

      {loading ? (
        <div className="p-4 text-gray-500"></div>
      ) : quotationData ? (
        <>
          {/* Item Details */}
          <div className="px-4 pt-4 pb-2">
            <h3 className="text-lg font-semibold text-[#524D4D]">Item Details</h3>
          </div>

          {/* Order ID Row */}
          <div className="flex justify-between items-center px-4 mb-2">
            <span className="text-sm text-gray-600 font-semibold">Order ID</span>
            <span className="text-sm text-gray-900 font-medium">{matchingDeliveryGroup?.readable_order_number}</span>
          </div>

          {/* Item Images */}
   {/* Item Images - Hide scrollbar completely */}
<div 
  className="overflow-x-auto overflow-y-hidden px-4 mb-2 hide-scrollbar"
>
  <div className="flex gap-2">
  {quotationData.delivery_groups?.flatMap((group) =>
    group.delivery_categories?.flatMap((category) =>
      category.items?.map((item, idx) => (
        <div
          key={item.item_id || item._id || idx}
          className="bg-gray-100 rounded-md flex items-center justify-center h-14 w-14 min-w-[56px] flex-shrink-0"
        >
          <img
            src={imageUrl + item.item_image}
            alt={item.item_name}
            className="h-10 w-10 object-contain"
            onError={(e) => {
              e.target.style.display = "none";
              e.target.parentNode.innerHTML = '<span class="text-xs text-gray-400 text-center">No </br> Image</span>';
            }}
          />
        </div>
      ))
    )
  )}
</div>

</div>







     
     


          {/* Item Tracking */}
          <div className="px-4 pt-5 pb-6">
            <h3 className="text-lg font-bold text-[#524D4D] mb-6">Order Tracking</h3>
            <div className="relative w-full max-w-xs mx-auto">
              <div className="flex flex-col space-y-0 z-10 relative">
                {steps.map((step, idx) => (
                  <div key={step.label} className="flex items-start relative">
                    {/* Circle and Connector */}
                    <div className="flex flex-col items-center" style={{ width: "2rem" }}>
                      <div className={`w-5 h-5 rounded-full flex items-center justify-center border-2 ${
                        step.completed ? "bg-red-500 border-red-500" : "bg-gray-400 border-gray-400"
                      }`}>
                        {step.completed && (
                          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                          </svg>
                        )}
                      </div>
                      {/* Connector line - only red if CURRENT step is completed AND next step is also completed */}
                      {idx < steps.length - 1 && (
                        <div
                          className={`w-0.5 ${
                            step.completed && steps[idx + 1].completed ? "bg-red-500" : "bg-gray-300"
                          }`}
                          style={{ height: "50px" }}
                        />
                      )}
                    </div>
                    {/* Label and Icon */}
                    <div className="ml-4 flex justify-between items-center w-full pr-2">
                      <span className={`text-sm font-medium ${
                        step.completed ? "text-[#000000]" : "text-gray-500"
                      }`}>
                        {step.label}
                      </span>
                      <img
                        src={stepImages[step.label]}
                        alt={step.label}
                        className={`w-8 h-6 object-contain ml-2 ${
                          step.completed ? "opacity-100" : "opacity-50"
                        }`}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* View Order Summary Button */}
          <div className="px-4 pb-4 mx-4">
            <button
              className="flex items-center justify-center w-full text-[#F43042] border border-gray-300 font-medium py-2 rounded-lg transition"
              onClick={() => navigate(-1)}
            >
              <img src={PurchaseOrderimg} alt="Order Summary" className="w-6 h-5 mr-2" />
              View Order Summary
            </button>
          </div>
        </>
      ) : (
        <div className="p-4 text-red-500">No data found for this order.</div>
      )}

      {/* Bottom Fixed Live Track Button */}
      <div className="fixed bottom-0 left-0 w-full bg-white px-4 py-2 z-50 border-t border-gray-200">
        <button
          className="w-full bg-red-500 text-white font-semibold py-2 rounded-lg hover:bg-red-600 transition"
          onClick={() => console.log("Live Track Clicked")}
        >
          Live Track Location
        </button>
      </div>

      <style>{`
  .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }
  .hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .line-clamp-1 {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`}</style>

    </div>
  );
};

export default TrackItems;
